import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#5542F6",
        terciary: "#BA52F8",
        secondary: "#424242",
        accent: "#8c9eff",
        error: "#E21C3D",
        success: "#04A24C",
      },
    },
  },
});
